import React, {useState} from 'react';
import {Platform, ScrollView, View} from 'react-native';
import {useNavigation} from '@react-navigation/native';

import Button from '/component/base/Button';
import Icon from '/component/base/Icon';
import ModalHeader from '/component/layout/ModalHeader';
import {DownlineProfile} from '/constant/TestIDs';
import {ACTION_TYPES, EVENT_NAMES} from '/enum/tealium.enum';
import {usePopup} from '/provider/PopupProvider';
import {useTranslation} from '/provider/TranslationProvider';
import {getTealiumUtilDefaultInstance} from '/util/tealium';
import testProperties from '/util/testing/testProperties';

import {CandidateInputFields} from '../../CandidateProfile/CandidateInputFields/CandidateInputFields';

import {styles} from './CandidateEditProfile.style';
import {
  generateOpenDeletePopover,
  handleBackButton,
  handleSave,
} from './CandidateEditProfile.util';
interface UrlDetailsType {
  url: string;
  label: string;
}
interface CandidateEditProfileProps {
  tt: (key: string, defaultValue?: string) => string;
  name: string;
  email: string;
  phone: string;
  newName: string;
  newEmail: string;
  newPhone: string;
  candidateId: string;
  urlDetails: UrlDetailsType[];
  deleteCandidate: () => Promise<void>;
  popoverShow: () => void;
  onClose: () => void;
  saveEditCandidateProfile: (params: any) => void;
  lastPaidRank: string;
  hasProfile: boolean;
  isReferral: boolean;
}

export const CandidateEditProfile: React.FC<CandidateEditProfileProps> = ({
  newName = '',
  newEmail = '',
  newPhone = '',
  candidateId = '',
  urlDetails = [],
  deleteCandidate = async () => {},
  popoverShow = () => {},
  saveEditCandidateProfile = () => {},
  lastPaidRank = '',
}) => {
  const sendEvent = getTealiumUtilDefaultInstance().generateTrackEvent({
    eventName: EVENT_NAMES.profileUpdate,
  });

  const navigation = useNavigation();
  const {tt} = useTranslation('screen.CandidateProfile.candidateEditProfile');

  const [name, setName] = useState(newName);
  const [email, setEmail] = useState(newEmail);
  const [phoneNumber, setPhoneNumber] = useState(newPhone);
  const [nameError, setNameError] = useState(false);
  const [socialLinks, setSocialLinks] = useState([]);
  const [emailError, setEmailError] = useState(false);
  const [phoneNumberError, setPhoneNumberError] = useState(false);
  const [socialLinksError, setSocialLinksError] = useState(false);
  const [socialLinkText, setSocialLinkText] = useState(new Map());
  const [fetchApi, setFetchApi] = useState(false);
  // @ts-expect-error TS(2339): Property 'hidePopup' does not exist on type 'unkno... Remove this comment to see the full error message
  const {hidePopup, showPopup} = usePopup();
  const [urlDetailsData, seturlDetailsData] = useState(urlDetails);

  const handleUrlDetailsChange = (newUrlDetails: any) => {
    seturlDetailsData(newUrlDetails);
  };

  const handleDeleteProfile = async () => {
    await deleteCandidate();
    sendEvent({
      userId: candidateId,
      updated_fields: 'none',
      action: ACTION_TYPES.remove,
      lastPaidRank: lastPaidRank,
    });
    navigation.goBack();
    navigation.goBack();
  };
  return (
    <ModalHeader
      isProfileScreen
      onClose={() => {
        handleBackButton({
          name,
          phoneNumber,
          email,
          newName,
          newEmail,
          newPhone,
          navigation,
          showPopup,
          hidePopup,
        });
      }}
      closeIconName={'chevron-left'}
      title={tt('candidateProfile', 'Edit Candidate profile')}
      actionLabel={tt('save', 'Save')}
      onActionPress={
        !fetchApi
          ? () => {
              handleSave({
                name,
                email,
                phoneNumber,
                newName,
                newEmail,
                newPhone,
                urlDetailsData,
                seturlDetailsData,
                setFetchApi,
                setNameError,
                setPhoneNumberError,
                setEmailError,
                setSocialLinksError,
                saveEditCandidateProfile,
                socialLinkText,
                navigation,
                socialLinks,
                setSocialLinks,
                candidateId,
                lastPaidRank,
              });
            }
          : () => {}
      }
      style={{base: styles.base}}>
      <View style={styles.mainView}>
        {Platform.OS === 'web' ? (
          <View style={styles.webScrollContainer as any}>
            <View style={styles.contentContainer}>
              <CandidateInputFields
                name={name}
                email={email}
                phoneNumber={phoneNumber}
                setName={setName}
                setEmail={setEmail}
                setPhoneNumber={setPhoneNumber}
                // @ts-expect-error TS(2322): Type 'boolean' is not assignable to type 'string'.
                nameError={nameError}
                setNameError={setNameError}
                // @ts-expect-error TS(2322): Type 'boolean' is not assignable to type 'string'.
                emailError={emailError}
                setEmailError={setEmailError}
                // @ts-expect-error TS(2322): Type 'boolean' is not assignable to type 'string'.
                phoneNumberError={phoneNumberError}
                setPhoneNumberError={setPhoneNumberError}
                // @ts-expect-error TS(2322): Type 'boolean' is not assignable to type 'string'.
                socialLinksError={socialLinksError}
                socialLinkText={socialLinkText}
                setSocialLinksError={setSocialLinksError}
                setSocialLinkText={setSocialLinkText}
                popoverShow={popoverShow}
                isEditScreen={true}
                urlDetailsData={urlDetailsData}
                seturlDetailsData={handleUrlDetailsChange}
                socialLinks={socialLinks}
                setSocialLinks={setSocialLinks}
                isLink={true}
              />
              <View style={styles.deleteButtonContainer}>
                <Button
                  type="textLink"
                  onPress={generateOpenDeletePopover(
                    {popoverShow},
                    handleDeleteProfile,
                  )}
                  style={{
                    base: styles.inputBox,
                    text: styles.textStyle,
                  }}
                  {...testProperties(
                    DownlineProfile.candidateProfileDeleteButton,
                    true,
                  )}>
                  <Icon name={'trash'} style={styles.trashIcon} /> Delete
                  candidate profile
                </Button>
              </View>
            </View>
          </View>
        ) : (
          <ScrollView contentContainerStyle={styles.contentContainer}>
            <CandidateInputFields
              name={name}
              email={email}
              phoneNumber={phoneNumber}
              setName={setName}
              setEmail={setEmail}
              setPhoneNumber={setPhoneNumber}
              // @ts-expect-error TS(2322): Type 'boolean' is not assignable to type 'string'.
              nameError={nameError}
              setNameError={setNameError}
              // @ts-expect-error TS(2322): Type 'boolean' is not assignable to type 'string'.
              emailError={emailError}
              setEmailError={setEmailError}
              // @ts-expect-error TS(2322): Type 'boolean' is not assignable to type 'string'.
              phoneNumberError={phoneNumberError}
              setPhoneNumberError={setPhoneNumberError}
              // @ts-expect-error TS(2322): Type 'boolean' is not assignable to type 'string'.
              socialLinksError={socialLinksError}
              socialLinkText={socialLinkText}
              setSocialLinksError={setSocialLinksError}
              setSocialLinkText={setSocialLinkText}
              popoverShow={popoverShow}
              isEditScreen={true}
              urlDetailsData={urlDetailsData}
              seturlDetailsData={handleUrlDetailsChange}
              socialLinks={socialLinks}
              setSocialLinks={setSocialLinks}
              isLink={true}
            />
            <View style={styles.deleteButtonContainer}>
              <Button
                type="textLink"
                onPress={generateOpenDeletePopover(
                  {popoverShow},
                  handleDeleteProfile,
                )}
                style={{
                  base: styles.inputBox,
                  text: styles.textStyle,
                }}
                {...testProperties(
                  DownlineProfile.candidateProfileDeleteButton,
                  true,
                )}>
                <Icon name={'trash'} style={styles.trashIcon} /> Delete
                candidate profile
              </Button>
            </View>
          </ScrollView>
        )}
      </View>
    </ModalHeader>
  );
};

export default CandidateEditProfile;
